//import { shepherdConstants } from '@app/common/components/shepherdGuide/common/shepherd-constants';

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProjectsLocalHistoryService = (function () {
    function ProjectsLocalHistoryService(sessionService) {
        var _this = this;
        var observerCallbacks = [];
        this.registerObserverCallback= function(callback) {
            observerCallbacks.push(callback);
        };
        var notifyObservers = function () {
            angular.forEach(observerCallbacks, function (callback) {
                callback();
            });
        };
        this.AddProjectHistory = function (project, userId) {
           
            var lastVisitedProjects = _this.sessionService.get("lastVisitedProjects_" + userId);
            if (lastVisitedProjects == null) {
                lastVisitedProjects = [];
            }
            var indexesToRemove = [];
            //create a list of indexes to remove
            lastVisitedProjects.forEach(function (item, index, items) {
                if (item.id == project.id) {
                    indexesToRemove.push(index);
                }
            });
            // remove from end
            indexesToRemove.reverse().forEach(function (item, index, items) {
                lastVisitedProjects.splice(item, 1);
            });
            // add current index
            lastVisitedProjects.push(project);
            if (lastVisitedProjects.length > 5) {
                lastVisitedProjects.splice(0, lastVisitedProjects.length - 5);
            }
            _this.sessionService.set("lastVisitedProjects_" + userId, lastVisitedProjects);
        
            notifyObservers();
        };
        this.GetProjectsHistory = function (userId) {

            //checks if its the first time we enter the site and clean project list history if so
            //if(!this.sessionService.get(shepherdConstants.SHEPHERD_WELCOME_MODAL_SHOWN))
            //{
            //    _this.sessionService.set("lastVisitedProjects_" + userId, null);
            //    return null;
            //}

            var history = _this.sessionService.get("lastVisitedProjects_" + userId);
            if (history == null || history.length == 0)
                return null;
            return history;

        };
        this.DeleteProjectHistory = function (userId,projectId) {
            var lastVisitedProjects = _this.sessionService.get("lastVisitedProjects_" + userId);
            var projectsAfterDelete = lastVisitedProjects.filter(function (m) { return m.id != projectId });
            _this.sessionService.set("lastVisitedProjects_" + userId, projectsAfterDelete);
            notifyObservers();
        };
        this.ClearProjectHistory = function (userId) {
            _this.sessionService.set("lastVisitedProjects_" + userId, []);
            notifyObservers();
        };
        this.sessionService = sessionService;
    }
    return ProjectsLocalHistoryService;
}());
ProjectsLocalHistoryService.$inject = ['sessionService'];
exports.ProjectsLocalHistoryService = ProjectsLocalHistoryService;
//# sourceMappingURL=projectsLocalHistoryService.js.map



// WEBPACK FOOTER //
// ./src/services/history/projectsLocalHistoryService.js